import React, { createContext, useState } from 'react';

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState(false);
  const [variant, setVariant] = useState('');
  const showToast = (newContent, newVariant) => {
    setContent(newContent)
    setVariant(newVariant)
    setOpen(true)
  }
  return (
    <ToastContext.Provider value={{ open, setOpen, content, setContent, variant, setVariant, showToast }}>
      {children}
    </ToastContext.Provider>
  );
};
